module.exports = __webpack_public_path__ + "img/contact.3b3dff2e.png";